<template>
  <div class="overflow-hidden flex flex-col max-h-svh min-h-svh">
    <div
      class="builder-nav py-4 bg-paper-1 flex items-center justify-center px-3 md:px-5">
      <div class="items-center absolute left-5 hidden md:flex">
        <svg-icon
          name="leftarrow-small-thin"
          class="mr-3" />
        <a
          href="#"
          class="underline"
          @click.prevent="goToHome">
          {{ t("book-builder.back-home") }}
        </a>
      </div>
      <div class="flex-1 flex justify-center">
        <a
          href="#"
          class="block w-32 md:w-40"
          @click.prevent="goToHome">
          <img
            :src="marqueSvg"
            class="block m-auto" />
        </a>
      </div>
    </div>
    <div class="flex flex-1 flex-col overflow-hidden">
      <div
        :style="progressStyles"
        class="h-3 book-builder-progress-bar w-full bg-green-2 flex-no-shrink"></div>
      <div
        class="w-full flex bg-white book-builder-grid flex-1 overflow-hidden bg-paper-2">
        <router-view key="view" />

        <!-- RIGHT IMAGE -->
        <builder-image />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import SvgIcon from "@/app/javascript/components/shared/SvgIcon.vue";
// eslint-disable-next-line import/no-unresolved
import marqueSvg from "@/app/assets/images/logo-marque.svg?url";

import BuilderImage from "./BuilderImage.vue";

export default {
  name: "GiftBuilder",
  components: {
    SvgIcon,
    BuilderImage
  },
  data() {
    return {
      marqueSvg,
      progress: 100
    };
  },
  computed: {
    ...mapState({
      rootPath: state => state.rootPath
    }),
    route() {
      return this.$route;
    },
    stepNumber() {
      return this.$route.meta.number;
    },
    progressStyles() {
      return {
        transform: `translateX(-${this.progress}%)`
      };
    }
  },
  watch: {
    route() {
      this.checkProgress();

      if (this.route.meta && this.stepNumber) {
        analytics.track("Viewed Book Builder", {
          step: this.route.name,
          number: this.stepNumber
        });
      }
    }
  },
  methods: {
    async goToHome() {
      await analytics.track("Gift Builder - Clicked Back to homepage");
      window.location.href = this.rootPath;
    },
    checkProgress() {
      const { routes } = this.$router.options;

      const currentIndex = routes.findIndex(
        route => route.path === this.route.path
      );

      const percentageToComplete = (currentIndex / routes.length) * 100;

      this.progress = 100 - percentageToComplete;
    }
  }
};
</script>

<style lang="scss" scoped>
.book-builder-grid {
  display: grid;

  @media (min-width: $screen-md-min) {
    grid-template-columns: 1fr 486px 486px 1fr;
  }
  @media (min-width: $screen-lg-min) {
    grid-template-columns: 1fr 640px 640px 1fr;
  }
}

.builder-left {
  grid-column: 2/3;
}

.builder-right {
  grid-column: 3/-1;
}

.builder-img {
  width: 100%;
  display: block;
  position: absolute;
}

.book-builder-progress-bar {
  transition: transform 0.4s ease-in-out;
  z-index: 2;
}
</style>
